// extracted by mini-css-extract-plugin
module.exports = {"work":"Experience_work__2PMLh","info":"Experience_info__2j_aV","date":"Experience_date__3eDIS"};